import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-get-token',
  templateUrl: './get-token.component.html',
  styleUrls: ['./get-token.component.less']
})
export class GetTokenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
